import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=50fcc31f&"
import script from "./Vendors.vue?vue&type=script&lang=js&"
export * from "./Vendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports